import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldWithValue } from '../../models/custom-fields.model';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Pipe to get the translated label for a field name
 * For custom fields in Arabic, use the custom field label from metadata
 * Otherwise, return the field name as-is for standard translation
 */
@Pipe({
  name: 'customFieldLabel',
})
export class CustomFieldLabelPipe implements PipeTransform {
  constructor(private transloco: TranslocoService) {}

  transform(fieldName: string, customFields: CustomFieldWithValue[] | null): string {
    // Check if this is a custom field and we're in Arabic layout
    if (customFields && customFields.length > 0) {
      const customField = customFields.find((field) => field.name === fieldName);
      if (customField && customField.label) {
        return customField.label;
      }
    }

    // Fall back to original field name for standard translation
    return fieldName;
  }
}
